module.exports = __webpack_public_path__ + "static/media/robbie-gay-resume.e6133edc.pdf";